import type { FaireProductEntity } from "../../entity_types/product";

export const p_bh3es3x5t4: FaireProductEntity = {
  token: "p_bh3es3x5t4",
  type: "product",
  name: "Hove Wood Salt / Pepper Mill (New)",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/5b01e95697c43006a1aa0acb675b3be4336932695828665b33604c78d6bf6cf1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2206f1a28536f77d39925b79fa8ce9a672916e238e5b7de98bc4715ba18d62b3.jpeg",
    "https://cdn.faire.com/fastly/832dc5d2767931ef753820463f68066b5d3b58b827168508a89e5abc0e9510b4.jpeg",
    "https://cdn.faire.com/fastly/1775f5f516e48af987c45f36e8021e2531ae804e085ccb4109110ae156a2acb6.jpeg",
    "https://cdn.faire.com/fastly/fb7fc3a683312239d0c32a08a63d3ac23ca90bcc9829927da80a7a151f4c9868.jpeg",
  ],
  priceDollars: 37.5,
  description:
    "Please note the mills are packed/sold separately, not in pairs.\n\nHOVE wooden mills have been designed to add a graphic form and a pop of colour to your table. With an elegant narrow and tall silhouette, HOVE mills elevate and add height to your table landscape while being ergonomic in use.\n\nCrafted from responsibly sourced hardwoods, with a ceramic grinding mechanism, which ensures a long-lasting performance. HOVE mills are available in a selection of neutral and bold colours. The colour is applied by staining the wood, combining the beauty of the natural woodgrain with carefully selected hues.\n\nThe mill can be used for both salt and pepper.\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥:\n• Sustainably Sourced American Maple with oiled finish\n• Sustainably Sourced Ash with colour-dyed finish\n\n𝐒𝐢𝐳𝐞:\n• Ø5.9 x 23.7 cm\n• Ø2.3” x 9.3”\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\nWipe with a damp cloth.\n\nDesigned in London.\nManufactured in P.R.C.",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:18.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
